import React, { useState, useEffect, useRef } from "react";
import { func, object, bool, array, string, oneOfType } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import Cookies from "universal-cookie";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import MobileLogo from "../../atoms/MobileLogo";
import SearchIcon from "../../atoms/icons/search-icon";
import VerticalMenubar from "../VerticalMenubar";
import Icon from "../../icons";
import AuthView from "../../rows/AuthView";
import Notifications from "../Notifications";
import { Facebook, Twitter } from "../../atoms/icons/StoryPageIcons";

import { setVerticalMenuBar } from "../../helper/actions";
import { useStyleMenubar, useDeviceWidth, logoRenderer } from "../../utils/react-utils";
import { pushEngage } from "../../helper/api";

import "./storyHeaderTopContent.m.css";

const StoryHeaderTopContent = ({
  isVerticalMenubar,
  setVerticalMenuBar,
  stickyHeader = false,
  story,
  hamburgerMenu,
  domainInfo,
  domainSlug = "",
  pushEngageApiKey,
  publisherAttributes
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dot, setDot] = useState(false);
  const ref = useRef(null);
  const cookies = new Cookies();
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  const fetchNotifications = () => {
    const offset = 0;
    const limit = 4;

    pushEngage(offset, limit, pushEngageApiKey).then(resp => {
      setNotifications(resp);
      if (cookies.get("notifications") && resp.length > 0) {
        resp[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
      } else {
        setNotifications(resp);
        resp.length > 0 && setDot(true);
      }
    });
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);
  const toggleNotifications = () => {
    if (!showNotifications) {
      cookies.set("notifications", notifications.length && notifications[0].notification_id);
      setDot(false);
    }

    setShowNotifications(!showNotifications);
  };

  return (
    <div styleName="base">
      <div
        styleName={`wrapper ${domainInfo && domainInfo.className ? domainInfo.className : ""}`}
        className="header-top-content"
      >
        <div styleName="header-left-content">
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            <HamburgerIcon
              onMenuToggle={toggleVerticalMenubar}
              isNavbarOpen={!!isVerticalMenubar}
              isDesktop={isDesktop}
            />
            {isDesktop && showSearchIcon && (
              <span styleName="search-icon" onClick={toggleSearchIcon}>
                <SearchIcon domainSlug={domainSlug} />
              </span>
            )}
            {isDesktop && <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>}
          </div>
          {isVerticalMenubar && (
            <VerticalMenubar
              isVerticalMenubar={isVerticalMenubar}
              isDesktop={isDesktop}
              domainInfo={domainInfo}
              toggleVerticalMenubar={toggleVerticalMenubar}
              hamburgerMenu={hamburgerMenu}
            />
          )}
          {domainSlug !== "protichinta" && (
            <div styleName="story-section" className="story-section">
              <Link href={story.sectionUrl}>{story.section}</Link>
            </div>
          )}
        </div>
        <div styleName="logo">
          {logoRenderer(<MobileLogo />)}
          {domainSlug === "protichinta" && (
            <div className="story-section" styleName="protichinta-story-secion">
              <Link href={story.sectionUrl}>{story.section}</Link>
            </div>
          )}
        </div>
        {!stickyHeader && (
          <div styleName="bell-button">
            {domainSlug === "protichinta" && isDesktop && (
              <span styleName="protichinta-icons">
                {showSearchIcon && (
                  <span styleName="protichinta-search-icon" onClick={toggleSearchIcon}>
                    <SearchIcon domainSlug={domainSlug} width="18" height="18" />
                  </span>
                )}
                {!showSearchIcon && <NavbarSearch />}
                <Link href="https://www.facebook.com/Protichinta/">
                  <Facebook color1="#fbf6de" color2="#555555" />
                </Link>
                <Link href="https://twitter.com/Protichinta">
                  <Twitter color1="#fbf6de" color2="#555555" />
                </Link>
              </span>
            )}
            <div styleName={`bell-container ${dot ? "new-notifications" : "no-notifications"}`}>
              <span styleName="bell" onClick={() => toggleNotifications()}>
                {" "}
                <Icon type="bell" className="bell" />
              </span>
              {showNotifications && <Notifications closeView={toggleNotifications} notifications={notifications} />}
            </div>
            {publisherAttributes.showLogin && <AuthView />}
          </div>
        )}
      </div>
    </div>
  );
};

StoryHeaderTopContent.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  hamburgerMenu: array,
  stickyHeader: bool,
  domainInfo: object,
  story: oneOfType([object, string]),
  domainSlug: string,
  pushEngageApiKey: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
    pageType: get(state, ["qt", "pageType"], ""),
    storyHeadline: get(state, ["qt", "data", "story", "headline"], ""),
    story: get(state, ["headerReducer", "showStoryHeader"], ""),
    domainSlug: get(state, ["qt", "domainSlug"]),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    pushEngageApiKey: get(state, ["qt", "config", "publisher-attributes", "push_engage_api_key"], null)
  };
};

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryHeaderTopContent);
